module.exports = __webpack_public_path__ + "img/notification_icon.2d69beb4.jpeg";